import { useEffect } from "react";
import { useState } from "react";
import UserManagementActions from "../../Actions/UserManagementActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import AppConstants from "../../Constants/AppConstants";

const AddCostCentreForUser = (props) => {
  const { addCostCentreDetails, costCentreList } = props;
  const [role, setRole] = useState("");
  const [costCentre, setCostCentre] = useState(AppConstants.DEFAULT_GUID);
  const [equipmentGroup, setEquipmentGroup] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const handleSubmit = (e) => {
    e.preventDefault();
    var costCentreData = {
      UserRoleId: !addCostCentreDetails.kostenstelle
        ? addCostCentreDetails.id
        : addCostCentreDetails.userRoleID,
      KostenstelleID: costCentre,
    };
    setGlobalSpinner(true);
    UserManagementActions.addOrUpdateCostCentreToUser(costCentreData);
  };

  useEffect(() => {
    if (addCostCentreDetails) {
      setRole(
        addCostCentreDetails.role == "Super_Admin"
          ? localization.organizationAdmin
          : addCostCentreDetails.role,
      );
      if (addCostCentreDetails.anlagegruppe) {
        setEquipmentGroup(
          addCostCentreDetails ? addCostCentreDetails.anlagegruppe : "",
        );
      } else {
        setEquipmentGroup("");
      }
    }
    setCostCentre("");
  }, [props]);

  return (
    <div
      className="modal fade"
      id="addCostCentreForUserModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addCostCentreForUserModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog">
        <div className="modal-content p-2">
          <div className="modal-header">
            <h5 className="modal-title" id="addCostCentreForUserTitle">
              {localization.addCostCenter}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addCostCentreForUserClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="mpdal-body">
            <form id="addCostCentreForUserForm" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="col">
                  <div className="form-outline">
                    <input
                      type="text"
                      id="role"
                      name="role"
                      disabled
                      className="form-control"
                      placeholder={localization.role}
                      value={role}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="col">
                  <div className="form-outline">
                    <input
                      type="text"
                      id="equipmentGroup"
                      name="plant"
                      disabled
                      className="form-control"
                      placeholder={localization.equipmentGroup}
                      value={equipmentGroup}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="col">
                  <div className="form-outline">
                    <select
                      className="form-control"
                      name="costCentre"
                      id="costCentre"
                      required
                      value={costCentre}
                      onChange={(e) => {
                        setCostCentre(e.target.value);
                      }}
                    >
                      <option value="">{localization.selectCostCenter}</option>
                      {costCentreList.map((row, index) => {
                        return (
                          <option key={index} value={row.id}>
                            {row.kost}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary btn-block"
                >
                  {localization.save}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCostCentreForUser;
